import { render, staticRenderFns } from "./ImageMsg.vue?vue&type=template&id=18e85efe&"
import script from "./ImageMsg.vue?vue&type=script&lang=js&"
export * from "./ImageMsg.vue?vue&type=script&lang=js&"
import style0 from "./ImageMsg.vue?vue&type=style&index=0&id=18e85efe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports